import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './surrounding-suburbs.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesSearchSurroundingSuburbs = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var heading = "Suburbs near ".concat(props.name);
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, heading), ___EmotionJSX("ul", {
    css: styles.items,
    className: "allhomes-search-surrounding-suburbs__items"
  }, props.items.map((division, index) => ___EmotionJSX("li", {
    key: "item-".concat(division.name),
    css: styles.item
  }, ___EmotionJSX("a", {
    className: "allhomes-search-surrounding-suburbs__items-link",
    css: styles.itemLink,
    href: division.href,
    onClick: () => {
      sendEvent('suburb-link-click', {
        position: index + 1,
        listingCategory: props.listingCategory,
        elementText: division.name,
        elementTitle: heading
      });
      if (division.onClick) {
        division.onClick();
      }
    }
  }, division.name)))));
};
AllhomesSearchSurroundingSuburbs.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func
  })),
  listingCategory: PropTypes.string
};
AllhomesSearchSurroundingSuburbs.defaultProps = {
  items: [],
  listingCategory: ''
};
export default AllhomesSearchSurroundingSuburbs;